import PropTypes from 'prop-types';
import Router from 'next/router';

import { FadeInAnimation, LinkUnderlineAnimation } from '../shared';
import FindASpaceCard from '../shared/find-a-space-card.component';

const SpaceSection = (props) => {
    
    const { title, paragraph } = props;

    return (
        <div id="space_section" className='space-section'>
            <FadeInAnimation>
                <div>
                    <h4>{title}</h4>
                    <div className='stay-style-section-paragraph-container'>
                        <p className='space-section-paragraph'>{paragraph}</p>
                        <div className='stay-style-section-link-container'>
                            <LinkUnderlineAnimation
                                id="learn_more_space"
                                href="/live/live-your-best-life#choose_header"
                            >
                                Learn More
                            </LinkUnderlineAnimation>
                        </div>
                    </div>
                </div>
            </FadeInAnimation>
            {renderCards()}
        </div>
    );
};

function renderCards() {
    const onBachelorClick = () => {
        Router.push('/bookings?category=bachelor').then(() => window.scrollTo(0, 0));
    };

    const onOneBedClick = () => {
        Router.push('/bookings?category=one-bedroom').then(() => window.scrollTo(0, 0));
    };

    const onTwoBedClick = () => {
        Router.push('/bookings?category=two-bedroom').then(() => window.scrollTo(0, 0));
    };

    return (
        <>
            <FadeInAnimation>

                <div className='main-grid-container main-grid-spacing-xs-3 stay-style-section-grid'>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/studio-apartment-icon.png"
                            imageAlt="studio"
                            title="Studio Apartment"
                            description="Live, work and play in one space"
                            onClick={onBachelorClick}
                        />
                    </div>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/bachelor-apartment_icon.png"
                            imageAlt="bunk-bed"
                            title="Bachelor Apartment"
                            description="Perfect for the professional single"
                            onClick={onBachelorClick}
                        />
                    </div>

                </div>

                <div className='main-grid-container main-grid-spacing-xs-3 stay-style-section-grid'>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/one-bedroom-icon.png"
                            imageAlt="bed"
                            title="One Bedroom Apartment"
                            description="Keep sleep separate and silent"
                            onClick={onOneBedClick}
                        />
                    </div>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/two-bedroom-icon.png"
                            imageAlt="people"
                            title="Two Bedroom Apartment"
                            description="Need to share with a friend?"
                            onClick={onTwoBedClick}
                        />
                    </div>

                </div>

            </FadeInAnimation>
        </>
    );
}

export default SpaceSection;

SpaceSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
};

